import type { SliderWidgetProps } from '../Slider.d';

export function filterByMatchParams(
  items: SliderWidgetProps['items'],
  match: SliderWidgetProps['match'],
) {
  return items.filter(
    ({ item }) =>
      item &&
      Object.keys(item).find(
        (key) =>
          (key as keyof typeof match.params) in match.params &&
          match.params[key as keyof typeof match.params] === item[key],
      ),
  );
}
